import React, { useState } from 'react';
import { Mail, Eye, EyeOff } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { callApi } from '../services/ApiServices';
import toast from 'react-hot-toast';
import Cookies from 'js-cookie';
import { useGlobalStates } from '../utlis/ClubsContext';

const Login = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
 const navigate = useNavigate();
 const {setUserRole} = useGlobalStates()


    const validate = () => {
    let newError = {};
    const emailRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!email) {
      newError.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      newError.email = "Invalid email address";
    }
    if (!password) {
      newError.password = "Password is required";
    }
    setErrors(newError);
    return Object.keys(newError).length === 0;
  };


  const handleSubmit = async(e) => {
    e.preventDefault();
       if(validate()) {
      try {
        setIsLoading(true)
        const response = await callApi({
          method:"post",
          url:"auth/login",
          data: {
            email: email,
            password: password,
            role: "admin"
          }
        })
        Cookies.set ("Admin_Token", response.accessToken , {expires:7})
        toast.success("Login successful")
        navigate("/dashboard")
       const role = Cookies.set("AccessPermission", response.access_permission)
        setUserRole(response.access_permission  )
        console.log("login time role",response.access_permission)
      } catch (error) {
        console.log("login error", error)
      }finally{
        setIsLoading(false)
      }
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-lightbg px-4 login-bg">
      <div className="">
        {/* Logo */}
        <div className="flex justify-center mb-12">
          <img
            src="/logo-drs.svg"
            alt="DRS Logo"
            className="h-20"
          />
        </div>

        {/* Welcome Text */}
        <div className="text-center mb-8">
          <h1 className="text-[40px] font-semibold text-black mb-3">
            Welcome to the DRS Admin Portal
          </h1>
          <p className="text-base text-[#4a5568]">
            Manage advertisers, clubs, campaigns, and transactions — all from one secure dashboard.
          </p>
        </div>

        {/* Login Form Card */}
        <div className="bg-white rounded-[30px] shadow-[0_0_30px_2px_#39BBD0] p-8">
          <form onSubmit={handleSubmit} noValidate>
            {/* Email Field */}
            <div className="mb-6">
              <label
                htmlFor="email"
                className="block text-[20px] font-medium text-black mb-2"
              >
                Email Id
              </label>
              <div className="relative">
                <input
                  id="email"
                  type="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value)
                     setErrors(prevErrors => ({ ...prevErrors, email: '' }))
                  }}
                  placeholder="Enter your email id"
                  className="w-full px-4 py-3 pr-12 border border-[#e2e8f0] rounded-lg text-base placeholder:text-[#a0aec0] focus:outline-none focus:border-[#06323A] focus:ring-1 focus:ring-[#06323A] transition-colors"
                  required
                />
                <Mail
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-[#a0aec0]"
                  size={20}
                />
                {errors.email && <span className="text-red-500">{errors.email}</span>}
              </div>
            </div>

            {/* Password Field */}
            <div className="mb-8">
              <label
                htmlFor="password"
                className="block text-[20px] font-medium text-black mb-2"
              >
                Password
              </label>
              <div className="relative">
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value)
                    setErrors(prevErrors => ({ ...prevErrors, password: '' }))
                  }}
                  placeholder="Enter your password"
                  className="w-full px-4 py-3 pr-12 border border-[#e2e8f0] rounded-lg text-base placeholder:text-[#a0aec0] focus:outline-none focus:border-[#06323A] focus:ring-1 focus:ring-[#06323A] transition-colors"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-[#a0aec0] hover:text-[#06323A] transition-colors"
                >
                  {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                </button>
                {errors.password && <span className="text-red-500">{errors.password}</span>}

              </div>
            </div>

            {/* Login Button */}
            <button
              type="submit"
              className="w-full bg-primary cursor-pointer text-white py-3 rounded-[40px]  text-lg font-medium hover:bg-[#084451] transition-colors shadow-[0_4px_12px_0_rgba(0,0,0,0.30)]"
              disabled={isLoading} 
            >
              {isLoading ?  <span className="inline-block w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></span> : "Login"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
